<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  (chartInstance)="setChart($event)"
  class="chartParent highcharts-light"
>
</highcharts-chart>
